import { QuizDialog } from "./QuizDialog";
import { useGetQuizResponse, useQuizProps } from "../../hooks";

export type Props = {
  onDone: () => void;
  onClose: () => void;
  isOpen: boolean;
  quizId: number;
};

/**
 * Container component for QuizDialog.
 * Handles data fetching and quiz navigation logic.
 */
export function QuizDialogContainer({
  onDone,
  onClose,
  isOpen,
  quizId,
}: Props) {
  const { quiz, quizResponse, isLoading } = useGetQuizResponse({ quizId });

  const {
    activeQuestionSet,
    buttonLabel,
    filterQuestionSet,
    handleNextQuestionObject,
    handlePreviousQuestionObject,
    isSubmitting,
    title,
    description,
    formData,
    stepIndex,
    totalSteps,
  } = useQuizProps({
    quiz,
    quizResponseId: quizResponse?.id,
    resetIndexKey: isOpen,
    onCompleteQuiz: () => onDone(),
  });

  return (
    <QuizDialog
      isOpen={isOpen}
      isLoading={isLoading || !quiz}
      onClose={onClose}
      activeQuestionSet={activeQuestionSet}
      buttonLabel={buttonLabel}
      filterQuestionSet={filterQuestionSet}
      onNext={handleNextQuestionObject}
      onBack={handlePreviousQuestionObject}
      isSubmitting={isSubmitting}
      title={title}
      description={description}
      formData={formData}
      stepIndex={stepIndex}
      totalSteps={totalSteps}
    />
  );
}

export default QuizDialogContainer;
